/** Tự sinh bởi scripts/fetch-youtube-rss.mjs lúc build, không sửa tay. */
export default [
  {
    "id": "6K038LnRcCs",
    "tieuDe": "Pha loãng cổ phần là gì? Founder còn 45% sau 3 vòng gọi vốn",
    "moTa": "Pha loãng là khi công ty phát hành thêm cổ phần cho người mới: số cổ phần bạn cầm không đổi nhưng chiếm phần nhỏ hơn trong một chiếc bánh lớn hơn. Trong ví dụ minh họa, nhóm sáng lập mất hơn nửa tỷ lệ sau ba vòng nhưng giá trị phần của họ tăng gần 9 lần. Pha loãng tốt là khi mỗi vòng bán ra ở định giá cao hơn vòng trước.",
    "ngayDang": "2026-10-27",
    "loat": "",
    "ganVao": [
      "/cong-cu/bang-co-phan-va-pha-loang"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "C3nZmFQ3Hvc",
    "tieuDe": "Pitch deck gọi vốn: 30 giây đầu nhà đầu tư nhìn gì?",
    "moTa": "Nhà đầu tư lướt pitch deck rất nhanh. 30 giây đầu quyết định họ có đọc tiếp hay không. Soát đủ 5 điều này trước khi gửi:",
    "ngayDang": "2026-10-26",
    "loat": "",
    "ganVao": [
      "/nhan-xet-deck"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "EfEmbMvS8_M",
    "tieuDe": "Gọi vốn vòng seed bao nhiêu là đủ? Startup Việt chỉ khoảng 0,5 triệu USD",
    "moTa": "Warhound vừa gọi 200 triệu USD vòng seed khi chưa có sản phẩm để bán. Đó là ngoại lệ. Ở Việt Nam, vòng pre-Series A trung vị năm 2023 chỉ khoảng 0,5 triệu USD. Tính số vốn cần gọi theo cột mốc của bạn, miễn phí: fundraising.vn/cong-cu/tinh-runway",
    "ngayDang": "2026-10-26",
    "loat": "",
    "ganVao": [
      "/cong-cu/tinh-runway"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "iXLQCBMscsM",
    "tieuDe": "Chia cổ phần đồng sáng lập: nghỉ sau 6 tháng có giữ không?",
    "moTa": "Vesting là cơ chế nhận cổ phần dần theo thời gian làm việc. Lịch phổ biến: 4 năm, cliff 12 tháng. Nghỉ trước tháng 12 thì không giữ gì, đủ 12 tháng thì nhận ngay 25%, sau đó nhận dần mỗi tháng. Nhà đầu tư luôn hỏi điều này để cổ phần đi cùng người thật sự ở lại xây công ty.",
    "ngayDang": "2026-10-26",
    "loat": "",
    "ganVao": [
      "/thuat-ngu/vesting-la-gi"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "ld5MgwKHp1c",
    "tieuDe": "Startup có lãi vẫn bị quỹ từ chối? Phép toán của quỹ VC",
    "moTa": "Quỹ 100 triệu USD phải trả về 310 triệu USD sau 10 năm, nên quỹ chỉ rót tiền vào công ty có thể trả lại cả quỹ. Video giải thích từng bước, kèm 5 câu hỏi nhà đầu tư dùng để chấm hồ sơ của bạn.",
    "ngayDang": "2026-11-01",
    "loat": "Mẹo gọi vốn",
    "ganVao": [
      "/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai",
      "/cong-cu/diem-san-sang-goi-von"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "Rut6gXFUsKs",
    "tieuDe": "8 lỗi biểu đồ khiến nhà đầu tư nghi ngờ con số của bạn",
    "moTa": "Cùng một bộ số, vẽ đúng hay vẽ sai là khác nhau. 8 lỗi trình bày số liệu hay gặp trong pitch deck và báo cáo nhà đầu tư, và cách sửa:",
    "ngayDang": "2026-10-29",
    "loat": "",
    "ganVao": [
      "/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "s0UXbxw7zl0",
    "tieuDe": "Miễn thuế 5 năm cho startup TP.HCM: Nghị quyết 59/2026",
    "moTa": "Startup khởi nghiệp sáng tạo có trụ sở chính tại TP.HCM được miễn thuế thu nhập doanh nghiệp 5 năm theo Nghị quyết 59/2026/NQ-HĐND, áp dụng từ kỳ tính thuế 2027.",
    "ngayDang": "2026-10-30",
    "loat": "",
    "ganVao": [],
    "status": "PUBLISHED"
  },
  {
    "id": "UVpagggRkf4",
    "tieuDe": "Term sheet vòng seed: 4 điều khoản founder phải đọc trước",
    "moTa": "4 điều khoản quyết định founder giữ được bao nhiêu sau vòng seed: mỗi lựa chọn được gì, mất gì, và đâu là thông lệ thị trường.",
    "ngayDang": "2026-11-01",
    "loat": "Mẹo gọi vốn",
    "ganVao": [
      "/mau/term-sheet-vong-seed",
      "/cong-cu/doc-term-sheet"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "vOLwDBRZZJs",
    "tieuDe": "Định giá startup: gọi 2 tỷ ở mức 8 tỷ, nhà đầu tư nhận bao nhiêu %?",
    "moTa": "Cùng một con số định giá, nhưng là pre-money hay post-money thì phần cổ phần trao cho nhà đầu tư khác hẳn. Pre-money 8 tỷ cộng 2 tỷ vốn mới thành post-money 10 tỷ, nhà đầu tư nhận 20%. Post-money 8 tỷ thì nhà đầu tư nhận 25%. Trước khi ký term sheet, luôn hỏi lại con số này là pre-money hay post-money.",
    "ngayDang": "2026-10-26",
    "loat": "",
    "ganVao": [
      "/thuat-ngu/pre-money-post-money"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "WHcTS0SGFps",
    "tieuDe": "Quỹ đầu tư hỏi gì khi thẩm định startup? Bài học từ IPO Anthropic",
    "moTa": "Hồ sơ IPO của Anthropic cho thấy doanh thu 6 tháng đầu 2026 đạt 16,3 tỷ USD, gấp hơn ba lần cả năm 2025 (khoảng 4,6 tỷ USD). Nhưng 47% doanh thu năm 2025 đi qua chợ ứng dụng đám mây của Amazon và Google, và vài khách hàng lớn chiếm phần đáng kể. Khi thẩm định, quỹ cũng hỏi startup đúng những câu này: top khách hàng chiếm bao nhiêu, phụ thuộc kênh nào, khách cũ có chi nhiều hơn không.",
    "ngayDang": "2026-10-27",
    "loat": "",
    "ganVao": [
      "/thuat-ngu/due-diligence"
    ],
    "status": "PUBLISHED"
  },
  {
    "id": "yR5qJSm4Eqc",
    "tieuDe": "Startup còn 560 triệu sống được mấy tháng? Khi nào nên gọi vốn",
    "moTa": "Runway là số tháng công ty còn hoạt động được với tiền mặt đang có: tiền mặt chia cho net burn (tổng chi trừ doanh thu). Một vòng angel hoặc pre-seed ở Việt Nam thường mất 3 đến 6 tháng, nên hãy bắt đầu gọi vốn khi còn 9 đến 12 tháng runway. Dưới 6 tháng là vùng nguy hiểm.",
    "ngayDang": "2026-10-27",
    "loat": "",
    "ganVao": [
      "/cong-cu/tinh-runway"
    ],
    "status": "PUBLISHED"
  }
];
